import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Sparkles } from "lucide-react";

const roles = [
  { title: "Performance Marketer", type: "Full Time", loc: "Noida" },
  { title: "Full-Stack Developer", type: "Full Time", loc: "Remote" },
  { title: "AI / ML Engineer", type: "Full Time", loc: "Hybrid" },
  { title: "UI / UX Designer", type: "Full Time", loc: "Noida" },
  { title: "Content Producer", type: "Full Time", loc: "Remote" },
  { title: "Affiliate Manager", type: "Full Time", loc: "Noida" },
];

export default function Careers() {
  return (
    <section id="careers" className="relative py-32 bg-[#070707] border-y border-white/5">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-5">
            <span className="eyebrow">Careers @ SYR</span>
            <h2 className="mt-6 text-4xl md:text-6xl font-semibold leading-tight">
              Build the future <br /> with <span className="text-gold-gradient">SYR Mediaworks.</span>
            </h2>
            <p className="mt-6 text-white/60 text-lg leading-relaxed">
              We're always looking for passionate developers, designers, marketers, AI
              innovators and creative minds who want to build products that impact millions.
            </p>
            <a href="https://apply.syr.co.in/" target="_blank" rel="noreferrer" className="btn-gold mt-10">
              Explore All Careers <ArrowUpRight size={18} />
            </a>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            {roles.map((r, i) => (
              <motion.a
                key={r.title}
                href="https://apply.syr.co.in/"
                target="_blank"
                rel="noreferrer"
                initial={{opacity:0, y:16}}
                whileInView={{opacity:1, y:0}}
                viewport={{once:true}}
                transition={{duration:0.5, delay: i*0.06, ease:[0.16,1,0.3,1]}}
                className="card-lift glass rounded-2xl p-6 flex flex-col justify-between group"
              >
                <div>
                  <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.28em] text-[#F4D983]">
                    <Sparkles size={12} /> Hiring
                  </div>
                  <div className="mt-4 text-xl font-semibold">{r.title}</div>
                  <div className="mt-2 text-sm text-white/50">{r.type} · {r.loc}</div>
                </div>
                <div className="mt-6 flex items-center justify-between">
                  <span className="text-sm text-white/60 group-hover:text-white transition-colors">Apply now</span>
                  <ArrowUpRight size={18} className="text-[#F4D983] group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                </div>
              </motion.a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
